'use strict';

import Component from 'generic.basecomponent';
import Flatpickr from "flatpickr";
import baseDatePickerConfig from 'base-datepicker-config';
import Cleave from 'cleave.js';

export default class DatePicker extends Component {
    constructor(el) {
        super(el);
        this.init();
    }

    init() {
        let format = this.container.getAttribute('data-format') || 'd/m/Y';
        let calendar = new Flatpickr(this.container, Object.assign({}, baseDatePickerConfig, {
            mode: "single",
            dateFormat: 'Y-m-d',
            altInput: true,
            altFormat: format,
            disableMobile: true,
            allowInput: true,

            onClose: function (selDates, dateStr, instance) {
                if (this.config.allowInput) {
                    let date = this.parseDate(this.altInput.value, this.config.altFormat);
                    if (date === null) {
                        //reset date
                        this.setDate(null, true, this.config.altFormat);
                    } else {
                        let formattedDate = this.formatDate(date, this.config.dateFormat);
                        if (formattedDate !== this.input.value) {
                            this.setDate(this.altInput.value, true, this.config.altFormat);
                        }
                    }
                }
            },

            //we need validation on real input, so show it for validation purpose but hide from ui
            onReady: [baseDatePickerConfig.onReady, function (dates, value, instance) {
                if (instance.altInput) {
                    instance.input.type = 'text';
                    instance.input.style.position = 'absolute';
                    instance.input.style.visibility = 'hidden';

                    new Cleave(instance.altInput, {
                        date: true,
                        datePattern: ["d", "m", "Y"],
                        delimiter: '/'
                    });
                }
            }]
        }));
    }
}



// WEBPACK FOOTER //
// ./app/components/datepicker/js/generic.datepicker.js